(ns dre.panels.views
  (:require
   [dre.components.backdrop :refer [backdrop]]
   [dre.components.error-view :refer [error-view]]
   [dre.components.icon :refer [svg]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.panels.db :as db]
   [dre.panels.events :as-alias panels]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))


(def component-name :panel)


(defn dismiss-button
  []
  [tooltip-wrapper "Dismiss" [:a {:class [(bem/bm :button :bare)
                                          (bem/be component-name :dismiss-button)]
                                  :href "#"
                                  :on-click #(rf/dispatch [::panels/clear])}
                              [svg :common :dismiss]]])


(defn base-panel
  []
  (let [error (r/atom nil)]
    (r/create-class
      {:display-name "base-panel"

       :component-did-catch
       (fn [_this e _info]
         (js/console.log e))  ; TODO: Notify Sentry

       :get-derived-state-from-error
       (fn [e]
         (reset! error e)
         #js {})

       :reagent-render
       (fn [panel data]
         (when panel
           [backdrop
            [:div
             {:class (bem/bm component-name (:id panel))}
             [dismiss-button]
             [:div
              {:class (bem/be component-name :content)}
              (if-let [err @error]
                [error-view (str err)]
                [(:view panel) data])]]
            {:on-outside-click (fn [e]
                                 (rf/dispatch [::panels/clear]))}]))})))


(defn view
  "Base component for all panels"
  []
  (let [panel-id @(rf/subscribe [::panels/current-panel-id])
        panel (get db/index panel-id)
        data @(rf/subscribe [::panels/current-panel-data])]
    [base-panel panel data]))
